// Core
import { 
    Box, 
    Button,
    Text,
    Modal,
    ModalOverlay,
    ModalCloseButton,
    ModalContent,
    useDisclosure,
    useColorModeValue,
    useColorMode
} from '@chakra-ui/react';

// Assets
import { ReactComponent as EmptyListGiveaways } from 'assets/svg/empty-list-giveaways.svg';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import Card from 'components/Card/Card';
import { InfoIcon } from 'components/Icons/Icons';

const TakeAPart = () => {
  const bgDividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDivider = useColorModeValue(bgDividerWhite, bgDividerDark);

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';
  
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
        <Card cursor="pointer" onClick={onOpen} padding="16px" my={{base: '16px', md: '40px'}} overflow="hidden" textAlign="center" position="relative">
            <Text 
                variant="title-lg"
                zIndex="3" 
                fontSize={{base: '20px', md: '24px', lg: '28px'}}
                fontStyle="italic"
                fontWeight="700"
                position="relative">You already participate!</Text>

            <Box zIndex="2" position="absolute" w="100%" bottom="0">
                <Box bg={bgDivider} transform="rotate(180deg)" h="2px" />
                { isDark && <Box bg="#099BFF" filter="blur(38px)" w="100%" h="36px" position="absolute" /> }
            </Box>

            <InfoIcon position="absolute" fontSize="24px" right="16px" top="50%" transform="translate(0px, -50%)" />

            { isDark ? <Lines className="abstract-lines" style={{ zIndex: 1}} />
                : <LinesWhite className="abstract-lines" style={{ zIndex: 1, opacity: 0.3 }} /> }
        </Card>

        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent className="modal__simple modal_take-a-part" 
                maxW={{ sm: '620px' }} 
                style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
            <ModalCloseButton style={{zIndex: '9'}} />
                <Box bg="#099BFF" filter="blur(100px)" w="90%" h="150px"
                    transform="translate(-50%, 0px)" left="50%" 
                    top="-200px" position="absolute" borderRadius="full" />

                <Box position="relative" p="0 8px 0 8px" textAlign="center">
                    <Text 
                        variant="title-lg"
                        zIndex="3" 
                        pt="24px"
                        fontSize="32px"
                        fontStyle="italic"
                        fontWeight="700"
                        position="relative">You already take a part!</Text>

                    <Text mt="16px" fontStyle="italic" p={{base: '0', md: '0 40px'}}>
                        All LMCT+ members with active membership automatically take a part in all giveaways! The number of automatic and free entries depends on your membership level.
                    </Text>

                    <Button mt="40px" onClick={onClose} variant="button-md">Got It!</Button>
                </Box>
               

            </ModalContent>
        </Modal> 
    </>
  );
};

export default TakeAPart;